import { memo } from 'react'
import { differenceInMinutes, format } from 'date-fns'
import { checkDate } from '../assets/assets_functions'
import { langTabInfos } from '../assets/langTabInfos'
import { useLang } from '../utils/hooks'

const TabInfos = ({ timeDomain, timeZone, maxSpeed, distance }) => {
  const { lang } = useLang()
  const choosenLang = lang === 'fr' ? langTabInfos.fr : langTabInfos.eng

  const thClass = 'is-size-7'
  const tdClass = 'is-size-7 has-text-info-dark has-text-right'

  const startTime = timeDomain[0]
  const endTime = timeDomain[1]

  const start = checkDate(new Date(startTime))
  const start_str = format(start, 'HH:mm', {
    timeZone: timeZone,
  })
  const end = checkDate(new Date(endTime))
  const end_str = format(end, 'HH:mm', {
    timeZone: timeZone,
  })

  const period = differenceInMinutes(end, start)

  const period_str = format(new Date(0, 0, 0, 0, period, 0, 0), 'H:mm')
  return (
    <div className="block" style={{ maxWidth: '400px' }}>
      <table className="table  is-fullwidth background-very-light-info">
        <tbody>
          <tr>
            <th className={thClass}>{choosenLang.sessionDuration}</th>
            <td className={tdClass}>
              {period_str +
                ' (' +
                start_str +
                ' - ' +
                choosenLang.ltl +
                ' ' +
                end_str +
                ') '}
            </td>
          </tr>
          <tr>
            <th className={thClass}>{choosenLang.maxSpeed}</th>
            <td className={tdClass}>
              {Math.round(maxSpeed * 10) / 10 + ' knt'}
            </td>
          </tr>
          <tr>
            <th className={thClass}>{choosenLang.distance}</th>
            <td className={tdClass}>{distance + ' km'}</td>
          </tr>
        </tbody>
      </table>
      {/* <div className="block" style={{ maxWidth: '400px' }}>
        <div>
          <div className="level">
            <div className="level-left">
              <div className="level-item">
                <div className="tag is-white is-normal has-text-weight-bold">
                  {choosenLang.sessionDuration}
                </div>
              </div>
            </div>
            <div className="level-right">
              <div className="level-item">
                <div className="tag is-white is-normal has-text-info-dark">
                  {period_str +
                    ' (' +
                    start_str +
                    ' - ' +
                    choosenLang.ltl +
                    ' ' +
                    end_str +
                    ') '}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="level">
            <div className="level-left">
              <div className="level-item">
                <div className="tag is-white is-normal has-text-weight-bold">
                  {choosenLang.maxSpeed}
                </div>
              </div>
            </div>
            <div className="level-right">
              <div className="level-item">
                <div className="tag is-white is-normal has-text-info-dark">
                  {Math.round(maxSpeed * 10) / 10 + ' knt'}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="level">
            <div className="level-left">
              <div className="level-item">
                <div className="tag is-white is-normal has-text-weight-bold">
                  {choosenLang.distance}
                </div>
              </div>
            </div>
            <div className="level-right">
              <div className="level-item">
                <div className="tag is-white is-normal has-text-info-dark">
                  {distance + ' km'}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  )
}
export default memo(TabInfos)
